var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferralIcon = function SvgReferralIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    fillRule: "evenodd",
    d: "M11.7 3.7c.7.4 1 1.3.6 2L5.8 18.2c-.4.7-1.3 1-2 .6-.7-.3-1-1.3-.6-2L9.7 4.3c.4-.7 1.3-1 2-.6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    fillRule: "evenodd",
    d: "M10.3 3.7c-.7.4-1 1.3-.6 2l6.5 12.5c.4.7 1.3 1 2 .6.7-.3 1-1.3.7-2L12.4 4.3c-.4-.7-1.3-1-2-.6z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 6,
    fill: "#FBD15D",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 13,
    y: 13,
    fill: "#E71D42",
    rx: 4.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    y: 13,
    fill: "#4AA2C4",
    rx: 4.5
  })));
};
export default SvgReferralIcon;